"use client"

import { useEffect, useState } from "react"
import Image from "next/image"
import { Card, CardContent } from "@/components/ui/card"
import { supabase } from "@/lib/supabase"
import Link from "next/link"

export interface NewsArticle {
    id: string
    image: string
    title: string
    date: string
    description: string
}

export default function NewsSection() {
    const [news, setNews] = useState<NewsArticle[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchNews = async () => {
            setLoading(true)
            try {
                const { data, error } = await supabase
                    .from("posts_public")
                    .select("*")
                    .order("created_at", { ascending: false })
                    .limit(4)

                if (error) throw new Error(error.message)
                const formattedData: NewsArticle[] = data.map((item: any) => ({
                    id: item.id,
                    image: item.thumbnail || "/placeholder.svg",
                    title: item.title,
                    date: item.created_at,
                    description: item.description,
                }))

                setNews(formattedData)
            } catch (err) {
                console.error("Lỗi khi tải tin tức:", err)
            } finally {
                setLoading(false)
            }
        }

        fetchNews()
    }, [])

    if (loading)
        return (
            <section className="py-12 bg-white text-center text-gray-500">
                Đang tải tin tức...
            </section>
        )

    return (
        <section className="pb-12 bg-white text-black">
            <div className="w-screen bg-[#273647] py-8 mb-8">
                <h2 className="text-4xl md:text-5xl font-display text-white text-center">
                    Bài viết - Tin tức
                </h2>
            </div>

            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {news.map((article) => (
                        <Link href={`/blog/${article.id}`}>
                        <Card  key={article.id} className="bg-white shadow-md overflow-hidden rounded-none">
                            <Image
                                src={article.image}
                                alt={article.title}
                                width={400}
                                height={250}
                                className="w-full h-48 object-cover"
                            />
                            <CardContent className="p-4">
                                <h3 className="text-lg font-bold text-black mb-2">{article.title}</h3>
                                <p className="text-sm text-gray-500 mb-2">{new Date(article.date).toLocaleDateString("vi-VN")}</p>
                                <p className="text-base text-gray-700">{article.description}</p>
                            </CardContent>
                        </Card>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    )
}
